import { BUTTON_ACTION_PAY } from '../constants/common';

/**
 *  This util will return true when the below "pay" mode critiera is met
 *  -- return true for pay mode ONLY if all three (button action as `pay` and `amount` and `supported display currency`) are provided by the merchant.
 *     If any of the three items is not provided by merchant then it becomes `continue` mode and amount is not displayed in the UX.
 *  -- In pay mode,
 *  -- Amount is displayed in DCF button and Non-Visa SDK init() will have these dsaTransactionOptions.
 *  -- Button mode on review screen is Pay
 *  -- Based on product(Manoj) recommendatiaon, we are not sending any default value for the trasnactionAmount object.
 *  -- When isButtonActionPay=true we will send this object otherwise dpaTransactionOption will skip sending this value
 * @param {object} vInitRequest
 * @returns {boolean}
 */
const getTransactionAmountDetails = vInitRequest => {
  const buttonAction = vInitRequest?.review?.buttonAction;
  const paymentRequestCurrencyCode = vInitRequest?.paymentRequest?.currencyCode;
  const paymentRequestTotal = vInitRequest?.paymentRequest?.total;
  const isButtonActionPay =
    (buttonAction &&
      buttonAction.toUpperCase() === BUTTON_ACTION_PAY &&
      paymentRequestTotal &&
      paymentRequestCurrencyCode) ||
    false;
  let transactionAmountDetails = {};

  if (isButtonActionPay) {
    transactionAmountDetails = {
      transactionAmount: {
        transactionAmount: paymentRequestTotal,
        transactionCurrencyCode: paymentRequestCurrencyCode
      }
    };
  }

  return transactionAmountDetails;
};

export default getTransactionAmountDetails;
